module.exports = __webpack_public_path__ + "static/media/Default.514b55a4.png";